import { Button } from "@component/button";
import { ArrowRightIcon } from "lucide-react";
import { StartupCandidate } from "@type/candidate";
import { parseFormat } from "@util/date";

interface Props {
    isSelected?: boolean;
    candidate: StartupCandidate;
    onSelectedCandidate: (candidate: StartupCandidate) => void;
}

export function StartupCandidateCard({ isSelected, candidate, onSelectedCandidate }: Props) {
    const handleViewProfileClick = (): void => {
        onSelectedCandidate(candidate);
    };

    return (
        <>
            <div
                className={`bg-white outline ${isSelected ? "outline-blue-600 outline-2" : "outline-gray-200 outline-1"} hover:outline-2 hover:outline-blue-500 rounded-lg p-5 cursor-pointer hover:shadow-md transition-shadow duration-200`}
                onClick={handleViewProfileClick}
            >
                <div className="flex items-start">
                    <img
                        className="h-12 w-12 rounded-full mr-4 object-cover hidden sm:block"
                        src={`${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/default_avatar.png`}
                    />
                    <div className="flex-1">
                        <div className="flex justify-between items-start">
                            <div>
                                <div className="flex flex-row gap-2">
                                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                        {candidate.startup_name}
                                    </h3>
                                    {candidate.is_incomplete && (
                                        <span className="text-xs text-red-600 font-medium bg-red-100 px-2 py-1 rounded-full self-center">
                                            Incomplete
                                        </span>
                                    )}
                                </div>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    Applied on {parseFormat(candidate.created_at, "D MMMM YYYY, HH:mma")}
                                </p>
                            </div>
                            <Button
                                size="sm"
                                className="transition-all duration-300 overflow-hidden relative hidden sm:block"
                                onClick={() => handleViewProfileClick()}
                            >
                                <span>View Details</span>
                                <ArrowRightIcon
                                    className="h-4 w-4 transition-all duration-300 absolute group-hover:relative -right-10 opacity-0 group-hover:opacity-100 group-hover:right-0"
                                />
                            </Button>
                        </div>
                        <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">
                            {candidate.startup_summary_short || "No summary available."}
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}
